/* eslint-disable import/no-default-export */
import React, { AnchorHTMLAttributes } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'app/gamma/src/types';

import { TestId } from '@trello/test-ids';
import Backbone from 'app/common/vendor/backbone';
import { navigateStart } from 'app/gamma/src/modules/state/ui/navigating';

interface StateProps {
  dispatch: Dispatch;
}

export interface RouterLinkProps
  extends AnchorHTMLAttributes<HTMLAnchorElement> {
  testId?: TestId;
}

const BackboneHistoryOptions = {
  trigger: true,
};

const differentUrl = (href: string): boolean => {
  return href !== window.location.href.replace(window.location.origin, '');
};

export class RouterLink extends React.Component<RouterLinkProps & StateProps> {
  private onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const { onClick, href, dispatch, target } = this.props;

    // If the Cmd or Control key is pressed during the click, or in safari, this is
    // a middle-click, honor the event and bypass the router
    const isMetaClick = e.ctrlKey || e.metaKey || (e.button && e.button !== 0);
    // If the target is set to a new window, honor the event and bypass the
    // router
    const isTargetBlank = target === '_blank';

    if (onClick) {
      onClick(e);
    }

    if (!e.defaultPrevented && !isMetaClick && !isTargetBlank) {
      e.preventDefault();
      // We only trigger navigateStart() if there is a URL and the URL is different to the current location. If we
      // trigger navigateStart() and the destination is the same, then the loading icon in the header will begin
      // spinning and never stop.
      if (href && differentUrl(href)) {
        dispatch(navigateStart());
      }

      try {
        Backbone.history.navigate(href, BackboneHistoryOptions);
      } catch (err) {
        // can't pushState an external link, so it's easier to let it fail and use window.location
        window.location.href = href as string;
      }
    }
  };

  render() {
    // Destructure `dispatch` even though we are not using
    // it here, so that we don't spread it to the anchor below
    const { dispatch, children, testId, ...rest } = this.props;

    return (
      // TODO:
      // The 'react-a11y-event-has-role' lint rule requires an element with an
      // event handler to have a 'role' attribute. An anchor has an implied
      // role of "link" per the spec, figure out why this is failing and turn
      // the rule back on.
      //
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
      <a {...rest} onClick={this.onClick} data-test-id={testId}>
        {children}
      </a>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatch,
});

export default connect(undefined, mapDispatchToProps)(RouterLink);
